import { RATING_THRESHOLDS } from "@/pages/CreatorAnalytics/constants";

const SCATTER_POINT_COLOR_GOOD = "#22c55e";
const SCATTER_POINT_COLOR_FAIR = "#f97316";
const SCATTER_POINT_COLOR_LOW = "#ef4444";

export const getScatterPointColor = (rating: number): string => {
  if (rating >= RATING_THRESHOLDS.GOOD) {
    return SCATTER_POINT_COLOR_GOOD;
  }
  if (rating >= RATING_THRESHOLDS.LOW) {
    return SCATTER_POINT_COLOR_FAIR;
  }
  return SCATTER_POINT_COLOR_LOW;
};
